import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import PropTypes from "prop-types";
import { ToolbarGroup } from "./toolbar-group.styles.es.js";
const propTypes = {
  children: PropTypes.node.isRequired
};
const ToolbarGroupRight = forwardRef(({ children }, ref) => /* @__PURE__ */ jsx(ToolbarGroup, { ref, flex: 0, $right: true, children }));
ToolbarGroupRight.propTypes = propTypes;
export {
  ToolbarGroupRight
};
